module.exports = __webpack_public_path__ + "static/SohneMono-light-50c68da1208d954508c951a73d32803d.woff2";